export default __webpack_public_path__ + "static/media/stb_greatek.56115876.jpg";